import React, { useEffect, useState } from "react";
import LessonNavBar from "components/Navbars/LessonNavBar.js";
import LessonFooterNav from "components/NavigationButton/LessonFooterNav.js";
import PromptLabHubComponent from "components/PromptLabHub/PromptLabHubComponent.js";
import { getLessonMetaByRoute, getNextLessonRoute } from "pages/claudeDevCourse/devLessonsRegistry.js";

const ROUTE = "CD_M1_L4";

const CD_M1_L4Component = ({ setAiPageContext, setCurrentCode, setCurrentOuput }) => {
    const meta = getLessonMetaByRoute(ROUTE);
    const nextRoute = getNextLessonRoute(ROUTE);
    const [allCompleted, setAllCompleted] = useState(false);

    useEffect(() => {
        setAiPageContext?.("claudeCourseLesson");
    }, [setAiPageContext]);

    return (
        <div className="lessonBackgroundColor1 lessonMain" style={{ minHeight: "100vh" }}>
            <LessonNavBar />
            <main id="main" tabIndex={-1} className="lessonMain flex-grow-1">
                <section>
                    <PromptLabHubComponent
                        lessonMeta={meta}
                        setallCheckboxesCompleted={setAllCompleted}
                        setCurrentCode={setCurrentCode}
                        setCurrentOuput={setCurrentOuput}
                    />
                </section>
                <LessonFooterNav route={ROUTE} nextRoute={nextRoute} showNext={allCompleted} />
            </main>
        </div>
    );
};

export default CD_M1_L4Component;
